export const Config = {
  GroundHeight: 200,
  BaseSpeed: 200,
  ProjectileSpeed: 1000,
  HeroJumpVelocity: -425,
  ObsticleMaxHeight: 64,
  FireOrbSpeed: 600,
  ShockwaveSpeed: 600,
} as const;
